module.exports = __webpack_public_path__ + "img/payment-security.4efaa9eb.png";